import React from 'react'

import {Alert, Colors, Popup, ListItem, Button} from '../../src/components/UI/index.js'
import {formSpacing, Check, Input} from '../../src/components/UI/forms/index.js'
import t from 'src/helpers/Languages.js'
import ScanXzing from './ScanXzing.js'
import ScanBarcodeDetector from './ScanBarcodeDetector.js'

class ScanFrame extends React.Component {
    constructor(props) {
        super(props)

        this.initialState = {
            isOpen: false,
            loading: false,
            barcode: '',
            lastScanned: '',
            message: '',
            info: '',
            error: ''
        }

        this.state = JSON.parse(JSON.stringify(this.initialState))

        this.audio = new Audio('/scan.wav')
        this.scanTimeout = null
    }

    componentWillUnmount() {
        clearTimeout(this.scanTimeout)
    }

    componentDidMount() {
        this.setState({deviceId: localStorage.savedCameraDeviceId}, async () => {
            if (this.state.deviceId !== 'externalScanner') {
                try {
                    const stream = await navigator.mediaDevices.getUserMedia({audio: false, video: {facingMode: 'environment'}})
                    const videoInputDevices = await navigator.mediaDevices.enumerateDevices()

                    const options = []

                    videoInputDevices.map((device) => {
                        if (device.deviceId && device.label) {
                            options.push({title: device.label, value: device.deviceId})
                        }
                    })

                    options.push({title: 'Externe scanner', value: 'externalScanner'})

                    const deviceIdIsPresent = this.state.deviceId && videoInputDevices.findIndex((obj) => obj.deviceId === this.state.deviceId) > -1

                    // https://stackoverflow.com/a/74313086/13664713
                    stream.getTracks().forEach((track) => track.stop())

                    if (deviceIdIsPresent) {
                        this.scanFrame.startVideo(this.state.deviceId)
                    } else {
                        this.popup.openOptions('Kies scanner', <CameraChoice ref={(ref) => this.camerachoice = ref} />, options, (option) => {
                            const saveCameraChoice = this.camerachoice.getSaveChoice()

                            if (saveCameraChoice) {
                                localStorage.savedCameraDeviceId = option.value
                            }

                            this.setState({deviceId: option.value}, () => {
                                if (option.value !== 'externalScanner') {
                                    this.scanFrame.startVideo(option.value)
                                } else {
                                    this.input.focus()
                                }
                            })
                        })
                    }
                } catch (err) {
                    this.onScanError(err)
                }
            } else {
                this.input.focus()
            }
        })
    }

    scan(barcode) {
        if (this.props.disabled) return

        if (barcode !== this.state.lastScanned) {
            this.audio.play()

            clearTimeout(this.scanTimeout)

            this.setState({lastScanned: barcode})

            this.scanTimeout = setTimeout(() => {
                this.setState({lastScanned: ''})
            }, 1000)

            this.setState({message: '', error: '', loading: true}, () => {
                this.props.onScan(barcode)
            })
        }
    }

    setMessage(message) {
        this.setState({message, loading: false})
    }

    setError(error) {
        this.setState({error, loading: false})
    }

    onScanError(err) {
        if (err.message === 'Permission denied') {
            this.setState({info: 'Je hebt geen toestemming gegeven voor het gebruik van de camera. klik op Help in de menubalk voor instructies om toestemming te geven.'})
        } else if (err.name === 'NotFoundError' || err.name === 'OverconstrainedError') {
            this.setState({deviceId: 'externalScanner', info: 'Geen camera gevonden, gebruik een externe scanner of handmatige invoer.'}, () => {
                this.input?.focus()
            })
        } else {
            this.setState({error: {err, customMessage: 'Foutmelding bij opvragen beschikbare camera\'s'}})
        }
    }

    render() {
        const {deviceId, barcode, message, info, error} = this.state
        const {suggestions, maxHeight, disabled} = this.props

        return (
            <div style={{width: '100%'}}>
                {deviceId && deviceId !== 'externalScanner' ?
                    ('BarcodeDetector' in window ?
                        <ScanBarcodeDetector
                            maxHeight={maxHeight}
                            onScan={this.scan.bind(this)}
                            onError={this.onScanError.bind(this)}
                            ref={(ref) => this.scanFrame = ref}
                        /> :
                        <ScanXzing
                            maxHeight={maxHeight}
                            onScan={this.scan.bind(this)}
                            onError={this.onScanError.bind(this)}
                            ref={(ref) => this.scanFrame = ref}
                        />
                    ) :
                    (
                        <div style={{flex: 1, flexShrink: 0, display: 'flex', flexDirection: 'column', width: '100%', alignItems: 'center'}}>
                            <i style={{fontSize: 150, color: Colors.grey20}} className='mdi mdi-barcode-scan' />
                        </div>
                    )
                }

                {/* The camera spans the width, the field and the messages keep a margin to the screen edges */}
                <div style={{paddingLeft: formSpacing.inset, paddingRight: formSpacing.inset}}>
                    <form
                        onSubmit={(event) => {
                            event.preventDefault()
                            barcode && this.scan(barcode)
                            this.setState({barcode: ''})
                        }}
                        disabled={disabled}
                    >
                        <div style={{display: 'flex', alignItems: 'center', columnGap: formSpacing.columnGap}}>
                            <Input
                                label={t('manualInput')}
                                value={barcode}
                                suggestions={suggestions}
                                onChange={(event) => this.setState({barcode: event.target.value.toUpperCase().replace(/\s/g, '')})}
                                disabled={disabled}
                                ref={(ref) => this.input = ref}
                            />

                            <Button variant='outline-white' type='submit' icon='mdi mdi-keyboard-return' />
                        </div>
                    </form>

                    {message &&
                        <Alert style={{marginBottom: 6, width: 'unset'}} variant='success'>{message}</Alert>
                    }

                    {info &&
                        <Alert style={{marginBottom: 6, width: 'unset'}} variant='info'>{info}</Alert>
                    }

                    {error &&
                        (error.err ?
                            <Alert style={{marginBottom: 6}} variant='errorHandler' err={error.err} customMessage={error.customMessage} /> :
                            <Alert style={{marginBottom: 6}} variant='error'>{error}</Alert>)
                    }
                </div>

                <Popup closeOnEscape={false} showOptionRadioButton ref={(ref) => this.popup = ref} />
            </div>
        )
    }
}

class CameraChoice extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            saveCameraChoice: false
        }
    }

    onChangeChecked() {
        this.setState({saveCameraChoice: !this.state.saveCameraChoice})
    }

    getSaveChoice() {
        return this.state.saveCameraChoice
    }

    render() {
        const {saveCameraChoice} = this.state

        return (
            <ListItem onClick={this.onChangeChecked.bind(this)}>
                <Check
                    label='Camera keuze onthouden'
                    checked={saveCameraChoice}
                />
            </ListItem>
        )
    }
}

export default ScanFrame
